import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";

import Notifications from "./components/notifications.js";
import DelayNotifications from "./components/delaynotifications.js";
import Product from "./components/product.js";
import { Link } from "react-router-dom";
import settings from "./settings.js";
import ReturnNotifications from "./components/returnnotifications.js";
import GPS from "./components/Gps.js";
import Competition from "./components/competition.js";
import Ads from "./components/ads.js";
import Contracts from "./components/contracten/index.js";
import Downloads from "./components/downloads.js";
import Dashprods from "./components/dashprods/index.js";
import THTNotifications from "./components/THT/index.js";
import Chart from "./components/chart.js";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { ads: [], data: [], newproducts: [], loading: false, top: 0 };
    this.handleUpdate = this.handleUpdate.bind(this);
    this.renderView = this.renderView.bind(this);
    this.renderThumb = this.renderThumb.bind(this);
  }
  UNSAFE_componentWillMount() {
    this.props.authenticate("/");
  }

  componentDidMount() {
    if (this.props.isSalesRep) {
      this.props.history.push("/hotels");
    } else {
      this.props.searchHandler2("");
      this.props.setSearchClient(0);
      this.loadAds();
      this.loadPromotions();
      this.loadNewProducts();
      this.props.closeMenu();
      this.props.addBreadcrumb([{ name: "", url: "", reset: true }]);
    }
  }

  componentDidUpdate() {
    if (this.props.isSalesRep) {
      this.props.history.push("/hotels");
      return null;
    }
  }

  loadAds() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url + "get_ads/" + window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ ads: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }
  loadPromotions() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_promotions/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }
  loadNewProducts() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_newproducts/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ newproducts: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }

  renderView({ style, ...props }) {
    const viewStyle = {};
    return (
      <div className="box" style={{ ...style, ...viewStyle }} {...props} />
    );
  }

  renderThumb({ style, ...props }) {
    const thumbStyle = { borderRadius: "50px", backgroundColor: "#AEAEAE" };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }

  handleUpdate(values) {
    // this.setState({ top });
  }

  clickAd(e, ad) {
    e.preventDefault();
    fetch(
      settings.server_url +
        "set_ad_click/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        ad.padv_id
    )
      .then((res) => res.json())
      .then((response) => {
        window.location = ad.padv_url;
      })
      .catch((error) => console.error("Error:", error));
  }

  render() {
    if (!this.props.isAuthenticated) return null;

    return (
      <Scrollbars
        renderView={this.renderView}
        renderThumbHorizontal={this.renderThumb}
        renderThumbVertical={this.renderThumb}
        onUpdate={this.handleUpdate}
        className="row ml-0 content"
      >
        <div className="col p-md-4 px-0 maxw1200">
          <div className="dashboard">
            {!this.props.isSalesRep && <Notifications />}
            {!this.props.isSalesRep && <ReturnNotifications />}
            {!this.props.isSalesRep && <DelayNotifications />}
            <Ads />
            <GPS />
            <THTNotifications />
            <Competition />
            <Downloads />
            <Contracts />
            <Chart />
          </div>
        </div>
      </Scrollbars>
    );
  }
}

export default Dashboard;
